import React from 'react'
import './instapagostStyle.css'

function ThanksForPay() {
  return (
    <div className='thanks-for-pay-container d-flex flex-column justify-content-center align-items-center'>
        <h3 className='mt-3 mb-5'>Su pago sido confirmado de forma exitosa</h3>
        <div className='thanks-for-pay-image'>
            <img className='uix-pay-vector' src={require('../../../../assets/img/png/thanks_for_pay.png')}/>
        </div>

        <p className="contact-support-text">Si tiene alguna consulta o requiere asistencia, nuestro equipo de soporte está disponible para ayudarle. Puede contactarnos a través de nuestro chat de WhatsApp <span><a href='https://api.whatsapp.com/send?phone=584242981662&text=Hola%2C%20consulta%20sobre%20mi%20pago%20en%20212global.com' className="whatsapp-link">haciendo clic aquí</a></span>.</p>
    </div>
  )
}

export default ThanksForPay